<template>
    <div>
        <h1>Labor Rate (Beta Testing)</h1>
        <div class="alert alert-warning">
            <h3><strong>New Labor Rate Calculation Testing</strong></h3>

            <p>
                We are experimenting with some different controls to get a closer result from the website to what we are
                getting in our financials. This data is for experimental purposes only while we continue to tweak the logic. <strong>Please continue to use the original labor report for operations use.</strong>
            </p><br />

            <p><strong>Here is how this report differs from the current labor rate calculation.</strong></p>
            <ul>
                <li>Rolling 7 day labor rate calculation</li>
                <li>Labor rate is calculated directly from sales rather than PSV</li>
                <li>Added capabilities for raising and lowering the sensitivity of labor data aggregation to allow the basis to be either a month, week, or day.</li>
            </ul>
        </div>
        <form @submit.prevent="runReport">
            <Options />
            <Results />
        </form>
    </div>
</template>
<script>
    import { store } from "@/store/Report.store.js";
    import Results from "@/components/reports/utils/Results";
    import Options from "./labor_opt";

    export default {
        name: 'labor_beta',
        components: { Results, Options },
        data() {
            return {
                state: store.state,
                optionFields: {
                    weeklyStartDate: {val: new Date(new Date().setDate(new Date().getDate() - new Date().getDay())).toLocaleDateString(), qsField: '[start_date]'},
                    startDate: {val: `${new Date(new Date().setDate(new Date().getDate() - new Date().getDay())).toLocaleDateString()} 00:00`, qsField: '[start_datetime]'},
                    endDate: {val: `${new Date(new Date().setDate(new Date().getDate() - new Date().getDay())).toLocaleDateString()} 00:00`, qsField: '[end_datetime]'},
                    reportType: {val: 'weekly', qsField: '[report_type]'},
                },
                groupByFields: {},
                dataFields: {}
            }
        },
        methods: {
            runReport: function() {
                store.runReport();
            }
        },
        created() {
            this.$appStore.setTitle(['Labor Rate (Beta)']);
            this.$set(store.state.results, this.$options.name, '');
            store.setReport(this.$options.name, this.optionFields, this.groupByFields, this.dataFields);
        }
    }
</script>